/* eslint-disable max-len */
import React from 'react';

const CBGVIcon = (props) => (
  <svg width='64' height='38' viewBox='0 0 64 38' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M55.2799 23.5111C56.4859 23.5111 57.3679 22.6471 57.3679 21.4411C57.3679 20.2351 56.4859 19.3711 55.2799 19.3711C54.0679 19.3711 53.1859 20.2351 53.1859 21.4411C53.1859 22.6471 54.0679 23.5111 55.2799 23.5111ZM55.2799 22.7551C54.5359 22.7551 54.0619 22.1851 54.0619 21.4411C54.0619 20.6911 54.5359 20.1271 55.2799 20.1271C56.0179 20.1271 56.4919 20.6911 56.4919 21.4411C56.4919 22.1851 56.0179 22.7551 55.2799 22.7551Z'
      fill='#4F5D68'
    />
    <path
      d='M61.5658 23.4391V19.4371H60.7078V21.0091H58.8178V19.4371H57.9658V23.4391H58.8178V21.7531H60.7078V23.4391H61.5658Z'
      fill='#4F5D68'
    />
    <path
      d='M37.2799 10.5111C38.4859 10.5111 39.3679 9.64709 39.3679 8.44109C39.3679 7.23509 38.4859 6.37109 37.2799 6.37109C36.0679 6.37109 35.1859 7.23509 35.1859 8.44109C35.1859 9.64709 36.0679 10.5111 37.2799 10.5111ZM37.2799 9.75509C36.5359 9.75509 36.0619 9.18509 36.0619 8.44109C36.0619 7.69109 36.5359 7.12709 37.2799 7.12709C38.0179 7.12709 38.4919 7.69109 38.4919 8.44109C38.4919 9.18509 38.0179 9.75509 37.2799 9.75509Z'
      fill='#4F5D68'
    />
    <path
      d='M43.5658 10.4391V6.43709H42.7078V8.00909H40.8178V6.43709H39.9658V10.4391H40.8178V8.75309H42.7078V10.4391H43.5658Z'
      fill='#4F5D68'
    />
    <path
      d='M30.9779 12.4356V8.43359H30.1199V10.0056H28.2299V8.43359H27.3779V12.4356H28.2299V10.7496H30.1199V12.4356H30.9779Z'
      fill='#4F5D68'
    />
    <path
      d='M3.97793 30.4356V26.4336H3.11993V28.0056H1.22993V26.4336H0.37793V30.4356H1.22993V28.7496H3.11993V30.4356H3.97793Z'
      fill='#4F5D68'
    />
    <path
      d='M20.9779 37.4391V33.4371H20.1199V35.0091H18.2299V33.4371H17.3779V37.4391H18.2299V35.7531H20.1199V37.4391H20.9779Z'
      fill='#4F5D68'
    />
    <path
      d='M23.6686 37.5111C24.8746 37.5111 25.7566 36.6471 25.7566 35.4411C25.7566 34.2351 24.8746 33.3711 23.6686 33.3711C22.4566 33.3711 21.5746 34.2351 21.5746 35.4411C21.5746 36.6471 22.4566 37.5111 23.6686 37.5111ZM23.6686 36.7551C22.9246 36.7551 22.4506 36.1851 22.4506 35.4411C22.4506 34.6911 22.9246 34.1271 23.6686 34.1271C24.4066 34.1271 24.8806 34.6911 24.8806 35.4411C24.8806 36.1851 24.4066 36.7551 23.6686 36.7551Z'
      fill='#4F5D68'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.8305 6.30897V0.992188H17.8305V6.30897L24.2501 9.9525V16.3362L27.6971 14.1181L28.7794 15.8L25.2027 18.1015L30.184 20.8412L35.9567 17.5848V12.9638H37.9567V17.6L44.3763 21.4171V29.1897L49.9753 32.1366L56.7547 28.66L63.4676 32.3893L62.4963 34.1376L56.717 30.9269L49.9633 34.3904L43.3825 30.9268L36.969 34.3936L30.1933 30.9189L26.3139 32.9362L25.3912 31.1618L29.1901 29.1863V22.5772L23.2694 19.3208L17.5546 22.7188L14.1789 28.2426L16.8257 32.7578L15.1003 33.7692L12.4405 29.2319H7.98193V27.2319H12.4526L15.0475 22.9859H11.2785V20.9859H13.192L9.41095 18.7377V9.9525L15.8305 6.30897ZM16.8305 8.04108L11.4109 11.117V17.6L16.8305 20.8225L22.2501 17.6V11.117L16.8305 8.04108ZM31.1901 22.5699V29.1824L36.9444 32.1334L42.3763 29.1972V22.5547L36.9435 19.3244L31.1901 22.5699Z'
      fill='#64737F'
    />
  </svg>
);
export default CBGVIcon;
